import { type Terminart, terminart as terminartEnum } from '../../../../../dtos';
import { content } from './VeranstaltungPropertiesChanger.content.ts';

export function printTerminartTooltip(terminart: Terminart): string {
  switch (terminart) {
    case terminartEnum.STANDARD:
      return 'Standardtermine sind Termine, die innerhalb der regulären halbjährigen Planungsphase angelegt werden.';
    case terminartEnum.ZUSATZ:
      return 'Zusatztermine sind Termine, die außerhalb der regulären Planungsphase, meist kurzfristig, zusätzlich angelegt werden.';
    case terminartEnum.ERSATZ:
      return 'Ersatztermine sind Termine, die als Ersatz für einen bisher geplanten Termin erstellt werden, weil der geplante Termin z. B. durch Krankheit des Trainers kurzfristig abgesagt werden musste';
    case null:
      return '-';
    default: {
      const exhaustiveCheck: never = terminart;
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`[printTerminartTooltip] Nicht implementierte Terminart: ${exhaustiveCheck}`);
    }
  }
}

export function printAusschreibungsprozessTooltip(): string {
  return content.ausschreibungsprozessTooltip;
}
